<template>
  <div class="page-account-logoff">
    <ym-img class="page-account-logoff-card"
            :src="require('@/assets/img/account_logoff/card.png')"
    />
    <div class="page-account-logoff-title">
      注销账户存在风险
    </div>
    <div class="page-account-logoff-summary">
      <div>注销账户后，您将永久失去该账户的所有信息、收听、下载、购买记录、VIP会员权益将被清空，且无法恢复。</div>
      <div>如需注销账号，请联系客服处理，电话咨询可能较多，请耐心等待。</div>
      <div>客服时间：周一至周五9:00-18:00</div>
      <div>客服电话：400-809-3885</div>
    </div>
    <a class="page-account-logoff-btn" href="tel:400-809-3885">联系客服注销</a>
  </div>
</template>

<script>
  export default {
    name: 'PageAccountLogoff',
    metaInfo: {
      title: '注销账号',
    },
    data() {
      return {};
    },
    methods: {},
    created() {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-account-logoff {
    min-height: 100%;
    background: @color-white;
    &-card {
      position: relative;
      left: 50%;
      width: 248px;
      height: 160px;
      margin: 80px 0 40px -124px;
    }
    &-title {
      margin-bottom: 60px;
      color: @color-text-base;
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      line-height: 1;
      text-align: center;
    }
    &-summary {
      width: 630px;
      margin: 0 auto 120px;
      color: @color-text-light;
      font-size: @font-size-base;
      line-height: 1.6;
      div {
        margin-bottom: 30px;
        &:last-child,
        &:nth-last-child(2) {
          margin-bottom: 0;
        }
      }
    }
    &-btn {
      width: 360px;
      height: 100px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-size: @font-size-medium;
      background: #02cccc;
      border-radius: 25px;
    }
  }
</style>
